(function ($, app) {
    if (!$) {
        return;
    }

    $(function () {
        if (window.toastr) {
            toastr.options = {
                closeButton: true,
                progressBar: true,
                positionClass: 'toast-top-right',
                timeOut: 3200,
            };
        }

        app.core.enhance(document);
        app.datatable?.init();
    });

    $(document).on('submit', '.js-login-form', function (event) {
        event.preventDefault();
        const $form = $(this);
        app.validation.clear($form);

        app.ajax.request({
            url: $form.attr('action'),
            method: 'POST',
            data: $form.serialize(),
        }).done((response) => {
            app.helpers.notify('success', response.message || 'Signed in successfully.');
            window.location.href = response.redirect;
        }).fail((xhr) => {
            app.validation.show($form, xhr.responseJSON?.errors);
            app.helpers.notify('error', xhr.responseJSON?.message || 'Unable to sign in.');
        });
    });

    $(document).on('submit', '.js-ajax-form', function (event) {
        event.preventDefault();
        const $form = $(this);
        const hasFiles = $form.find('input[type="file"]').length > 0;
        const formData = hasFiles ? new FormData(this) : $form.serialize();

        app.validation.clear($form);

        app.ajax.request({
            url: $form.attr('action'),
            method: hasFiles ? 'POST' : ($form.find('[name="_method"]').val() || $form.attr('method') || 'POST'),
            data: formData,
            processData: !hasFiles,
            contentType: hasFiles ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
        }).done((response) => {
            app.modal.close();
            app.datatable.reload();
            app.helpers.notify('success', response.message || 'Saved successfully.');
        }).fail((xhr) => {
            app.validation.show($form, xhr.responseJSON?.errors);
            app.helpers.notify('error', xhr.responseJSON?.message || 'Please check the highlighted fields.');
        });
    });

    $(document).on('click', '.js-delete-row', function () {
        const $button = $(this);

        app.ajax.request({
            url: $button.data('url'),
            method: 'DELETE',
        }).done((response) => {
            app.datatable.reload();
            app.helpers.notify('success', response.message || 'Deleted successfully.');
        });
    });

    $(document).on('click', '.js-restore-row', function () {
        const $button = $(this);

        app.ajax.request({
            url: $button.data('url'),
            method: 'POST',
        }).done((response) => {
            app.datatable.reload();
            app.helpers.notify('success', response.message || 'Restored successfully.');
        });
    });

    $(document).on('click', '.js-permissions-select-all', function () {
        $(this).closest('form').find('input[name="modules[]"]').prop('checked', true);
    });

    $(document).on('click', '.js-permissions-unselect-all', function () {
        $(this).closest('form').find('input[name="modules[]"]').prop('checked', false);
    });

    $(document).on('change', '.js-image-preview-input', function () {
        const file = this.files?.[0];
        const preview = document.querySelector($(this).data('preview'));

        if (!file || !preview) {
            return;
        }

        preview.src = URL.createObjectURL(file);
        preview.classList.remove('is-empty');
        $(this).closest('.upload-field').find('[data-upload-label]').text(file.name);
    });

    $(document).on('click', '.js-toggle-password', function () {
        const $target = $($(this).data('target'));
        const nextType = $target.attr('type') === 'password' ? 'text' : 'password';

        $target.attr('type', nextType);
        $(this).attr('aria-label', nextType === 'password' ? 'Show password' : 'Hide password');
    });
})(window.jQuery, window.ITConnect);
